<div style="background-color: #161616;" class="commission_container">
    <div class="flex justify-between border-bottom" style="padding: 27px 32px;">
        <h4>Commission Setup</h4>
        <img src="./assets/images/black/close.png" class="close-image" (click)="closeDialog()">
    </div>
    <div class="main">
        <form [formGroup]="commissionSettingsForm">
            <app-commission-input-group [lang]="lang" [units]=units [form]="commissionSettingsForm"
                [fieldName]="'Total Commission'" [selectedUnit]="'selectedTotalCommissionUnit'"
                [formControlNameRate]="'totalCommissionRate'" [formControlNameFixed]="'totalCommissionFixed'"
                (inputTotalChange)="inputTotalChange()">
            </app-commission-input-group>
            <div style="color: #B5BDC9; font-size: 14px; margin-top: 1.5rem; margin-bottom: 0.5rem; ">
                Choose payment plan
            </div>
            <div>
                <mat-radio-group formControlName="stageOption" fxLayout="column" fxLayoutGap="10px" color="primary"
                    (change)="stageOptionsChange($event)">
                    <mat-radio-button [value]=1 style=" width: 100%">
                        One-off Payment At Settlement
                    </mat-radio-button>
                    <div style="font-size: 12px; color: rgba(222, 222, 222, 0.4);margin-bottom: 10px;">The Payments will
                        be made when the
                        property is
                        unconditional
                    </div>
                    <mat-radio-button [value]=2 style="  width: 100%">
                        two-stage Payment
                    </mat-radio-button>
                    <div style="font-size: 12px; color: rgba(222, 222, 222, 0.4);margin-bottom: 10px;">The Payments will
                        be made when the
                        property is unconditional
                    </div>
                    <mat-radio-button [value]=3 style="  width: 100%">
                        3 stage Payment
                    </mat-radio-button>
                    <div style="font-size: 12px; color: rgba(222, 222, 222, 0.4);margin-bottom: 10px;">The Payments will
                        be made when the
                        property is unconditional and settled</div>
                </mat-radio-group>
            </div>
            <div style="margin-top: 1rem" *ngIf="commissionSettingsForm.get('stageOption').value">
                <table mat-table [dataSource]="dataSource" style="width: 100%">
                    <ng-container matColumnDef="stage">
                        <th mat-header-cell *matHeaderCellDef>Stage</th>
                        <td mat-cell *matCellDef="let element">{{element.stage}}</td>
                    </ng-container>
                    <ng-container matColumnDef="milestone">
                        <th mat-header-cell *matHeaderCellDef>Allocation Condition</th>
                        <td mat-cell *matCellDef="let element">
                            {{element.label}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="proportion">
                        <th mat-header-cell *matHeaderCellDef>Proportion</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.readOnly">
                                <ng-container
                                    *ngIf="this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1">
                                    {{commissionSettingsForm.get('totalCommissionRate').value}}%
                                </ng-container>
                                <ng-container
                                    *ngIf="this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 2">
                                    {{commissionSettingsForm.get('totalCommissionFixed').value | currency: '' : 'symbol'
                                    : '3.0'}}
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="!element.readOnly">
                                <ng-container
                                    *ngIf="this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 1">
                                    <ng-container *ngIf="dataSource.length === 1">
                                        {{this.commissionSettingsForm.get('totalCommissionRate').value}}%
                                    </ng-container>
                                    <ng-container *ngIf="dataSource.length > 1">
                                        <input currencyMask [(ngModel)]="element.proportion"
                                            [ngModelOptions]="{standalone: true}"
                                            [options]="{ prefix: '', thousands: ',', decimal: '.', precision: 2}"
                                            class="custom-proportion">%
                                    </ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="this.commissionSettingsForm.get('selectedTotalCommissionUnit').value === 2">
                                    A$
                                    <input [(ngModel)]="element.absolute" class="custom-proportion" currencyMask
                                        [options]="{ prefix: '', thousands: ',', decimal: '.', precision: 2}"
                                        [ngModelOptions]="{standalone: true}">
                                </ng-container>
                            </ng-container>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </form>
    </div>
    <div *ngIf="notEqualError && isSubmitted" style="font-size: 14px; color: #d3442d; padding: 0 24px">
        *The sum of each stage's commission must be equal to total commission.
    </div>
    <div fxLayout="row" fxLayoutAlign="end center" style="padding: 1rem 1.5rem;">
        <!--        <mat-slide-toggle color="primary">Show processing timeline to agents</mat-slide-toggle>-->
        <button mat-raised-button
            style="background: #161616; color: #DEDEDE; border-radius: 8px; width: 100%; height: 52px; border: 1px solid #DEDEDE; "
            (click)="createOrUpdateCommissionSettings()">
            Update
        </button>
    </div>
</div>